import MatchEvent from '../interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';

export default function (matchEvents: Array<MatchEvent>): boolean {
  let hasExtraTime = false;
  if (matchEvents) {
    matchEvents.forEach((matchEvent) => {
      if (matchEvent.matchEventTypeId === MatchEventType.FIRST_HALF_EXTRA_TIME) {
        hasExtraTime = true;
      }
    });
  }
  return hasExtraTime;
}
